/*  BUNDLE CARDS THAT SHOW YOU WHAT IS IN THE BUNDLE.

    A bundle cover has an impossible job. It has to say "this is four kits" in one square
    at 200 pixels, and every way of doing it is a compromise: slice them and each slice is
    too thin to recognise, tile them and each tile is too small, pick one and the other
    three are invisible. The static cover is the best of those, and it still cannot tell
    you that the third slice is Coding Files V3.

    So the static cover stops trying to. It says BUNDLE, in Carlos's own visual language,
    and the card tells you the rest when you point at it: the real cover of each kit in
    turn, with its name. Nobody has to open the bundle to find out what is in it.

    WHY NOT A SECOND IMAGE ON HOVER. Impulse already does that and so does most of Shopify.
    One swap can show a second kit. It cannot show a fourth.

    1450ms A FRAME, ARRIVED AT FROM BOTH SIDES. It ran at 1100 first and four kits went by
    in four seconds, too fast to read the name, which is the part that answers the
    question. 1700 fixed the reading and started to feel like waiting. This sits between
    them: a four kit bundle shows its whole hand in just under six seconds.

    IT CAN BE RUN TWICE, and has to be. The search results page swaps its cards in without
    a page load, so the cards this bound on first load are gone and the new ones have never
    been seen. window.evRebind picks up anything new; the marker attribute means the cards
    that survived a swap are not bound a second time, which would otherwise leave two
    intervals racing on one card.

    THE IMAGES ARE FETCHED WHEN THE CARD IS SEEN, NOT WHEN IT IS HOVERED, and that split is
    why this file has a loader in it. They started as ordinary lazy images and never loaded
    at all: they sit at opacity 0 underneath the cover, and a browser is entitled to treat
    that as not worth fetching, so the first hover faded to four blank frames. Loading them
    eagerly instead would add up to nine image requests to a grid of twenty cards that most
    visitors never hover. Priming on intersection is the middle.

    IT STARTS AT THE FIRST MEMBER, and the base cover stays underneath the whole time. If a
    member image is slow or 404s, the card shows the real cover rather than a hole.

    TOUCH GETS IT WITHOUT HOVER. There is no hover on a phone, so on a coarse pointer the
    cycle runs by itself while the card is on screen, and stops when it is not.

    IT RESPECTS prefers-reduced-motion by not running at all.

    NOTHING HERE TOUCHES THE LINK. See ev-buy.js for why a browse surface must never behave
    like a buy button.  */
(function () {
  'use strict';

  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var coarse = window.matchMedia && matchMedia('(hover: none)').matches;
  var HOLD = 1450;

  function wire (shot) {
    if (shot.hasAttribute('data-ev-cycle-bound')) return;
    shot.setAttribute('data-ev-cycle-bound', '');

    var frames = [].slice.call(shot.querySelectorAll('[data-ev-frame]'));
    var label  = shot.querySelector('[data-ev-cycle-label]');
    if (frames.length < 2) return;

    var i = 0, timer = null, running = false, primed = false;

    function prime () {
      if (primed) return;
      primed = true;
      frames.forEach(function (f) {
        var src = f.getAttribute('data-src');
        if (src && !f.getAttribute('src')) f.setAttribute('src', src);
      });
    }

    function show (n) {
      frames[i].classList.remove('is-on');
      i = (n + frames.length) % frames.length;
      frames[i].classList.add('is-on');
      if (label) label.textContent = frames[i].getAttribute('data-name') || '';
    }

    function start () {
      if (running) return;
      running = true;
      prime();
      shot.classList.add('is-cycling');
      show(0);
      timer = setInterval(function () { show(i + 1); }, HOLD);
    }

    function stop () {
      if (!running) return;
      running = false;
      clearInterval(timer);
      shot.classList.remove('is-cycling');
      frames.forEach(function (f) { f.classList.remove('is-on'); });
      if (label) label.textContent = '';
      i = 0;
    }

    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { prime(); if (coarse) start(); }
        else if (coarse) { stop(); }
      });
    }, { threshold: coarse ? 0.55 : 0.01 }).observe(shot);

    if (coarse) return;

    var card = shot.closest('a') || shot;
    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focus', start);
    card.addEventListener('blur', stop);
  }

  function bindAll () {
    document.querySelectorAll('[data-ev-cycle]').forEach(wire);
  }

  window.evRebind = bindAll;
  bindAll();
})();
